
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "row": "row-77e0fd8a",
    "fit-width": "fit-width-77e0fd8a",
    "fit-height": "fit-height-77e0fd8a",
    "fit-both": "fit-both-77e0fd8a",
    "center": "center-77e0fd8a",
    "middle": "middle-77e0fd8a",
    "spacing-none": "spacing-none-77e0fd8a",
    "spacing-normal": "spacing-normal-77e0fd8a",
    "spacing-narrow": "spacing-narrow-77e0fd8a",
    "spacing-wide": "spacing-wide-77e0fd8a",
    "fitWidth": "fit-width-77e0fd8a",
    "fitHeight": "fit-height-77e0fd8a",
    "fitBoth": "fit-both-77e0fd8a",
    "spacingNone": "spacing-none-77e0fd8a",
    "spacingNormal": "spacing-normal-77e0fd8a",
    "spacingNarrow": "spacing-narrow-77e0fd8a",
    "spacingWide": "spacing-wide-77e0fd8a"
};
exports.styleSource = ".row-77e0fd8a{display:flex;flex-direction:row}.fit-width-77e0fd8a{width:100%}.fit-height-77e0fd8a{height:100%}.fit-both-77e0fd8a{width:100%;height:100%}.center-77e0fd8a{justify-content:center}.middle-77e0fd8a{align-items:center}.spacing-none-77e0fd8a>*{margin:0}.spacing-normal-77e0fd8a>*{margin-right:1em}.spacing-normal-77e0fd8a>*:last-child{margin-right:0}.spacing-narrow-77e0fd8a>*{margin-right:.5em}.spacing-narrow-77e0fd8a>*:last-child{margin-right:0}.spacing-wide-77e0fd8a>*{margin-right:2em}.spacing-wide-77e0fd8a>*:last-child{margin-right:0}";
exports.default = exports.styles;
            
module.moduleType = "style";
